(() => {
  const ROOT_SELECTOR = '[data-collection-description-root]';
  const ITEM_SELECTOR = '.CD-fold-item';
  const TITLE_SELECTOR = '.CD-fold-title';
  const CONTENT_SELECTOR = '.CD-fold-content';

  const normalizeExternalLinks = (container) => {
    container.querySelectorAll('a').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.href);

        if (url.origin !== window.location.origin) {
          link.setAttribute('target', '_blank');

          if (!link.hasAttribute('rel')) {
            link.setAttribute('rel', 'noopener noreferrer');
          }
        }
      } catch (error) {
        if (!link.hasAttribute('rel')) {
          link.setAttribute('rel', 'noopener noreferrer');
        }
      }
    });
  };

  const getRoots = (scope = document) => {
    if (!scope) {
      return [];
    }

    if (scope instanceof Element) {
      const roots = [];

      if (scope.matches(ROOT_SELECTOR)) {
        roots.push(scope);
      }

      roots.push(...scope.querySelectorAll(ROOT_SELECTOR));
      return roots;
    }

    return Array.from(document.querySelectorAll(ROOT_SELECTOR));
  };

  const getDirectChild = (parent, selector) => {
    return Array.from(parent.children).find((child) => child.matches(selector)) || null;
  };

  const isTopLevelItem = (item) => {
    if (!item.parentElement) {
      return true;
    }

    return !item.parentElement.closest(ITEM_SELECTOR);
  };

  const createAccordionItem = (item) => {
    const title = getDirectChild(item, TITLE_SELECTOR);
    const content = getDirectChild(item, CONTENT_SELECTOR);

    if (!title || !content) {
      return null;
    }

    const details = document.createElement('details');
    details.className = 'collection-description-accordion__item';

    const summary = document.createElement('summary');
    summary.className = 'collection-description-accordion__summary';
    summary.innerHTML = title.innerHTML;

    const panel = document.createElement('div');
    panel.className = 'collection-description-accordion__content';

    Array.from(content.childNodes).forEach((node) => {
      panel.appendChild(node.cloneNode(true));
    });

    normalizeExternalLinks(panel);

    details.appendChild(summary);
    details.appendChild(panel);

    return details;
  };

  const initAccordion = (root) => {
    if (!root || root.dataset.collectionDescriptionAccordionReady === 'true') {
      return;
    }

    const items = Array.from(root.querySelectorAll(ITEM_SELECTOR)).filter(isTopLevelItem);
    let validItemsCount = 0;

    items.forEach((item) => {
      const accordionItem = createAccordionItem(item);

      if (!accordionItem) {
        return;
      }

      item.replaceWith(accordionItem);
      validItemsCount += 1;
    });

    if (validItemsCount > 0) {
      root.classList.add('collection-description-root--has-accordion');
    }

    root.dataset.collectionDescriptionAccordionReady = 'true';
  };

  const initCollectionDescriptionAccordion = (scope = document) => {
    getRoots(scope).forEach(initAccordion);
  };

  window.initCollectionDescriptionAccordion = initCollectionDescriptionAccordion;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCollectionDescriptionAccordion(document);
    }, { once: true });
  } else {
    initCollectionDescriptionAccordion(document);
  }
})();
